import { useState } from "react";
import PropTypes from "prop-types";
import SwitchMembershipSectionWrapper from "../section-wrapper";
import Button from "common/components/elements/buttons/primary";
import MemberLabel from "./modules/member-label";

const SwitchMembershipMembersList = ({
   membersData,
   onRemoveMemberFromList,
}) => {
   const [isOpenList, setIsOpenList] = useState(true)

   return (
      <SwitchMembershipSectionWrapper>
         <div
            className='w-full flex flex-col gap-4'
         >
            <div
               className='w-full flex items-center justify-between'
            >
               <span
                  className='font-medium text-major leading-5'
               >
                  {membersData.length > 1 ? 'Members' : 'Member'}
               </span>

               <Button
                  iconName={ isOpenList ? 'arrow-up' : 'arrow-down' }
                  padding={ 0 }
                  classNames='!w-fit !h-fit'
                  primaryColor={ false }
                  backgroundColor='transparent'
                  fontIconColor='secondary'
                  onClick={ () => setIsOpenList(!isOpenList) }
               />
            </div>
            {
               isOpenList && (
                  <div
                     className='w-full flex flex-wrap gap-2'
                  >
                     {
                        membersData.map(item => (
                           <MemberLabel
                              key={ item.id }
                              username={ item.nickname || item.user_name || item.username }
                              avatarSrc={ item.avatar_compressed_src }
                              canRemove={ membersData.length > 1 }
                              onClickRemove={ () => onRemoveMemberFromList(item.id) }
                           />
                        ))
                     }
                  </div>
               )
            }
         </div>
      </SwitchMembershipSectionWrapper>
   )
}

SwitchMembershipMembersList.propTypes = {
   membersData: PropTypes.array,
   onRemoveMemberFromList: PropTypes.func,
}

export default SwitchMembershipMembersList;
